import React from "react";
import classes from "./SideDrawerToggle.module.css";

type SideDrawerToggleProps = { click: () => void };

const SideDrawerToggle: React.FC<SideDrawerToggleProps> = (props) => {
    return (
        <div className={classes.SideDrawerToggle} onClick={props.click}>
            <div></div>
            <div></div>
            <div></div>
        </div>
    );
};

export default SideDrawerToggle;
